// ** Initial State
const initialState = {
  data: [],
  total: 1,
  params: {},
  selectedUser: null,
  popup: {
    data: [],
    view: {},
    total: 0,
    params: {}
  },
  rowData: {
    data: []
  },
  dataDefault: [],
  open_modal: false,
  data_modal: [],
  dataDefault_activity: [],
  open_modal_activity: false,
  data_modal_activity: [],
  agent_wallet: [],
  summary_list: [],
  round_lock_number: null,
  round_close_number: null,
  round_summarize: null,
  review_file: null,
  lottery_ticket_summary: null,
  // Bugget Rate
  bugget_rate_list: {
    data: [],
    total: 0
  },
  bugget_rate_detail: null,
  loading: false
}

const lotteryNew = (state = initialState, action) => {
  switch (action.type) {
    case 'SMS_SET_GET_DATA':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'POPUP_SET_GET_DATA':
      return {
        ...state,
        popup: {
          ...state.popup,
          data: action.data,
          total: action.totalPages,
          params: action.params
        }
      }
    case 'POPUP_ID_GET_DATA':
      return {
        ...state,
        popup: {
          ...state.popup,
          view: action.data[0]
        }
      }
    case 'CONTACT_SET_GET_DATA':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'ROLE_SET_GET_DATA':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'ROLE_EDIT_GET_DATA':
      return {
        ...state,
        rowData: {
          data: action.data
        }
      }
    case 'ROLE_DEFAULT_GET_DATA':
      return {
        ...state,
        dataDefault: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'WHEEL_OPEN_MODAL':
      return {
        ...state,
        open_modal: action.open_modal
      }
    case 'WHEEL_OPEN_EDIT_MODAL':
      return {
        ...state,
        data_modal: action.data
      }
    case 'WHEEL_REWARD_GET_DATA':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'ACTIVITY_OPEN_MODAL':
      return {
        ...state,
        open_modal_activity: action.open_modal
      }
    case 'ACTIVITY_OPEN_EDIT_MODAL':
      return {
        ...state,
        data_modal_activity: action.data
      }
    case 'ACTIVITY_REWARD_GET_DATA':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_DATA_AGENT_WALLET':
      return {
        ...state,
        agent_wallet: action.data
      }
    case 'ROUND_SUMMARY_LIST':
      return {
        ...state,
        summary_list: action.data,
        loading: action.loading
      }
    case 'ROUND_SUMMARIZE':
      return {
        ...state,
        round_summarize: action.data
      }
    case 'REVIEW_FILE':
      return {
        ...state,
        review_file: action.data
      }
    case 'LOTTERY_TICKET_SUMMARY':
      return {
        ...state,
        lottery_ticket_summary: action.data
      }
    case 'ROUND_LOCK_NUMBER_LIST':
      return {
        ...state,
        round_lock_number: {
          data: action.data,
          total: action.totalPages
        }
      }
    case 'ROUND_CLOSE_NUMBER_LIST':
      return {
        ...state,
        round_close_number: {
          data: action.data
        }
      }
    
    // Bugget Rate Cases
    case 'BUGGET_RATE_LIST':
      return {
        ...state,
        bugget_rate_list: {
          data: action.data,
          total: action.total
        }
      }
    case 'BUGGET_RATE_GET_BY_ID':
      return {
        ...state,
        bugget_rate_detail: action.data
      }

    default:
      return { ...state }
  }
}

export { lotteryNew }
